import * as Actions from 'store/actions/app/product_prices.actions'

const initialState = {
  loading_product_prices_list_by_attributes: false,
  product_prices_list_by_attributes: [],

  loading_product_cost_by_last_purchases: false,
  product_cost_by_last_purchases: null,
}

export default function productPricesReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PRODUCT_PRICES_LIST_BY_ATTRIBUTES: {
      return {
        ...state,
        loading_product_prices_list_by_attributes: action.payload.loading,
        product_prices_list_by_attributes: action.payload.data ?? state.product_prices_list_by_attributes,
      }
    }
    case Actions.RESET_PRODUCT_PRICES_LIST_BY_ATTRIBUTES: {
      return {
        ...state,
        product_prices_list_by_attributes: [],
      }
    }
    case Actions.GET_PRODUCT_COST_BY_LAST_PURCHASE: {
      return {
        ...state,
        loading_product_cost_by_last_purchases: action.payload.loading,
        product_cost_by_last_purchases: action.payload.data ?? state.product_cost_by_last_purchases,
      }
    }
    default: {
      return state
    }
  }
}
